import { FlowDurationUnits, type FlowWaitBlockV2, FlowWaitBlockV2Schema } from 'flow-schema';

import { WaitV2FormFields } from './FormFields';
import { waitV2DocumentationMarkdown } from './documentation';
import { CodeMirrorLanguageType } from '../../../../../Code/types';
import { type BlockConfigProps } from '../../../types';

export const waitConfigV2: BlockConfigProps<FlowWaitBlockV2['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'wait',
  defaultConfig: {
    duration: {
      value: 1,
      units: FlowDurationUnits.Minutes,
    },
    waitUntilDate: '',
  },
  configFields: {
    getLanguageFieldValues: (config) => {
      return {
        [CodeMirrorLanguageType.DoubleBraceNodeFields]: [config.waitUntilDate],
      };
    },
    schema: FlowWaitBlockV2Schema.shape.config,
    FormFields: WaitV2FormFields,
  },
  documentationMarkdown: waitV2DocumentationMarkdown,
};
